import { mfgConfirmDialogClass, ghostBtnClass } from "@/components/manufacturing/manufacturingSurfaceClasses";
import type { MfgMaterial, MfgPlant } from "@/lib/manufacturingClient";
import { PlantMaterialRequestCompose } from "./PlantMaterialRequestCompose";

export function PlantMaterialRequestPopover(props: {
  open: boolean;
  onClose: () => void;
  enabled: boolean;
  plants: MfgPlant[];
  materials: MfgMaterial[];
  defaultPlantId?: string;
  onSubmitted: (poNumber: string) => void;
}) {
  if (!props.open) return null;
  return (
    <div
      className="fixed inset-0 z-[9200] flex items-start justify-center bg-black/40 p-4 pt-16"
      role="presentation"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) props.onClose();
      }}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-label="Inventory request"
        className={`max-h-[min(85vh,40rem)] w-full max-w-lg overflow-y-auto ${mfgConfirmDialogClass}`}
      >
        <div className="flex items-start justify-between gap-2">
          <p className="text-xs text-gray-500 dark:text-zinc-400">Stays on the build pipeline.</p>
          <button type="button" className={ghostBtnClass} onClick={props.onClose}>
            Close
          </button>
        </div>
        <PlantMaterialRequestCompose
          enabled={props.enabled}
          plants={props.plants}
          materials={props.materials}
          defaultPlantId={props.defaultPlantId}
          onSubmitted={(poNumber) => {
            props.onSubmitted(poNumber);
            props.onClose();
          }}
        />
      </div>
    </div>
  );
}
